import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../css/stripe/stripeCheckoutForm.css";
// Firebase Services
import { collOrders, db } from '../firebase'
import { collection, doc, setDoc, arrayUnion, updateDoc, deleteField, getDocs } from 'firebase/firestore'

import { AuthContext } from "../context/auth.context.js";
import { orderMailService } from "../services/mailing.services.js"
import '../css/SendMailToBuy.css'


function SendMailToBuy(props) {
  const navigate = useNavigate()
  console.log("props dentro de SEnMail", props)

  const { total, name, email } = props.newOrder
  const { newOrder } = props
  console.log("neWOrder dentro de SEnd>Maikl", newOrder)
  const { setErrorMessage } = props

  const { user, getUserData } = useContext(AuthContext)
  const [isFetching, setIsFetching] = useState(false);








  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newOrder.address === "" || newOrder.name === "" || newOrder.province === "" || newOrder.town === "" || newOrder.country === "" || newOrder.cp === "") {
      setErrorMessage("Debe rellenar todos los campos")
      return
    }
    
    // Creación del número de pedido
    const currentData = new Date()
    console.log("Fecha actual", currentData);
    const year = currentData.getFullYear();
    const month = ('0' + (currentData.getMonth() + 1)).slice(-2); // Agregamos 1 porque los meses comienzan desde 0
    const day = ('0' + currentData.getDate()).slice(-2);
    const dateToOrderNumber = year + month + day + "00"
    console.log("Fecha para numero de orden", parseInt(dateToOrderNumber));

    try {
      const orderRef = collection(db, "orders")
      const newOrderRef = doc(orderRef)
      const orderDocs = []
      let orderNumber;
      setIsFetching(true)
      const querySnapshot = await getDocs(collOrders);
      console.log("querySnapshot de órdenes", querySnapshot)
      querySnapshot.forEach((doc) => {
        orderDocs.push({...doc.data()})
        
      })
      if(orderDocs.length === 0){
        orderNumber = dateToOrderNumber + "1"
      }else{
        let maxOrderNumber = "1";
        orderDocs.forEach((each)=> {
          let numeroPedido = parseInt(each.orderNumber.toString().substring(10));
          if (numeroPedido > maxOrderNumber) {
            maxOrderNumber = numeroPedido;
          }
        }) 
        orderNumber = dateToOrderNumber + maxOrderNumber 
        console.log("orderNumber antes de sumarle 1", orderNumber)
        orderNumber = parseInt(orderNumber) + 1
        console.log("orderNumber después de sumarle 1", orderNumber)
      }

      setIsFetching(false) 
  
      newOrder.id = newOrderRef.id
      newOrder.state = "pendiente"
      newOrder.orderNumber = orderNumber
      await setDoc(newOrderRef, newOrder)
      const userToUpdate = doc(db, "users", user.id)
      await updateDoc(userToUpdate, {
        orders: arrayUnion(newOrder)
      })

      newOrder.orderCart.forEach(async (each) => {
        console.log("each dentro de orderCheckout", each);

        if (each.contieneTallas === false) {
          let newQuantity = each.stock - each.cantidad
          const productById = doc(db, "products", each.id);
          // alert(`Actualizando producto ${each.name}, con la cantidad ${each.stock} - ${each.cantidad} ${newQuantity}`)
          await updateDoc(productById, { stock: newQuantity });

        }

        if (each.contieneTallas === true) {
          const productById = doc(db, "products", each.id);
          each.size.forEach((eachSize) => {
            if (eachSize.name === each.sizeSelected) {
              // alert(`Actualizando producto ${each.name}, con la cantidad ${eachSize.stock} - ${each.cantidad} en la talla: ${eachSize.name}`)
              eachSize.stock = eachSize.stock - each.cantidad
            }
          })

          await updateDoc(productById, { size: each.size })
          // alert(`Actualizando producto ${each.name}`)

        }
      });
      
      await updateDoc(userToUpdate, {
        cart: []
      })
      await orderMailService(newOrder)
      alert(`Su pedido se ha realizado correctamente, se ha enviado un correo al mail: ${email}`)
      getUserData()
      navigate("/")

    } catch (error) {
      console.log(error)
    }
    if (isFetching === true) {
      return <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    }
  };

return (
  <div>
    <form onSubmit={handleSubmit} className="form">
      <p className="payment-info">
        El servicio de pagos online está actualmente <strong>deshabilitado</strong>.  
        Si deseas continuar con tu pedido, el equipo de <strong>MasQDance</strong> se pondrá en contacto contigo en los próximos días para ofrecerte toda la información.  
        Para cualquier duda, escríbenos a <a href="mailto:ventas@masqdance.com">ventas@masqdance.com</a>.
      </p>
      
      <button className="buy">Solicitar Pedido</button>
    </form>
  </div>
);
}


export default SendMailToBuy;
